import  React from 'react';
import CustomSelect from "../General/customSelect";

const EditingSettingsTableRow = (props) => {
	const {
		question,
		childQuestionOptionName,
		editingSetting,
		changeEditingSettings,
		editingSettingsOptions,
		editingSettingValue
	} = props;
	return (
		<tr className={"appFormRefSettings-tr "}>
			<td>
				{question.isParent ===true?
					<div>
						{
							question.isRequired?
								<div className="">
									<span>{question.name}</span><span className="appFormRefSettings-required">*</span>
								</div>
								:
								<div className=""><span>{question.name}</span></div>

						}

					</div>
					:
					<div>
						{
							question.isRequired?
								<div>
									<span className="appFormRefSettings-child-question">
										{childQuestionOptionName}
									</span>
									<span>{' - ' + question.name}</span
									><span className="appFormRefSettings-required">*</span>
								</div>
								:
								<div>
									<span className="appFormRefSettings-child-question">
										{childQuestionOptionName}
									</span>
									{ ' - ' + question.name}
								</div>
						}

					</div>

				}
			</td>
			<td>
				{(editingSetting && editingSetting.id) && (
					<div>
						<CustomSelect
							name={editingSetting.id}
							onChange={(evt) => changeEditingSettings({key: evt.target.name, value: evt.target.value})}
							value={editingSettingValue}
							options={editingSettingsOptions}
						/>
					</div>
				)}
			</td>
		</tr>
	)
};

export default EditingSettingsTableRow;